import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-page-gamelist.pcss';

import './../tt-page/tt-page'
import './../tt-toolbar/tt-toolbar'
import './../tt-gamelist/tt-gamelist'
import {TTUtil} from "../../utils/tt-util";

export default class TTPageGamelist extends LitElement {
    static get properties() {
        return {
            data: {
                type: Array
            },
            user: {
                type: Object
            }
        };
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
<tt-page>
    <div slot="header">
        <tt-toolbar .user=${this.user}></tt-toolbar>
    </div>
    <div slot="body">
        <tt-gamelist
                .games=${this.data}
                @game-selected="${this.toGameDetail}">
        </tt-gamelist>
        
        ${this._isEmpty(this.data) ? this.renderEmpty() : ""}
    </div>
</tt-page>
`;
    }

    _isEmpty(array) {
        return array && array.length === 0;
    }

    renderEmpty() {
        return html`
        <h1>Pause</h1>
        <p>Aktuell sind keine Spiele im offiziellen Liveticker vorhanden! Du kannst aber jederzeit für deinen eigenen Verein einen Liveticker erstellen. <a href="/community">Hier geht´s zur Community-Version!</a></p>
        `;
    }

    toGameDetail(evt) {
        let game = evt.detail.game;

        TTUtil.getApp(this).navigateTo(game.link);
    }
}

window.customElements.define('tt-page-gamelist', TTPageGamelist);
